import React, { useState, useEffect} from 'react';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css'
import MesCards from '../../../utils/MesCards'
import '../../../App.css'
import { useTranslation} from 'react-i18next'
import LogoFb from '../../../assets/logofacebook.png'
import LogoInsta from '../../../assets/logoInsta.png'
import LinkHyperlink from '../../../assets/pnghyperlink.png'
import { ExternalLink } from 'react-external-link';
 
 const ArtistesDyn = (props) => {
    
    const Artist = MesCards.find(x=> x.NameURL === props.match.url.substr(10))  // récupère ce qui suit mon url
    
    const { t } = useTranslation();
    const [photoIndex, setPhotoIndex] = useState(0) ;
    const [isOpen, setIsOpen] = useState(false) // photo pas touche

    const [showFb, setshowFb] = useState(false)
    useEffect(() => {
      if (Artist.fb) {
      setshowFb(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []) ;

    const [showInsta, setshowInsta] = useState(false)
    useEffect(() => {
      if (Artist.insta) {
      setshowInsta(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []) ;

    const [showSitePerso, setshowSitePerso] = useState(false)
    useEffect(() => {
      if (Artist.SitePerso) {
      setshowSitePerso(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []) ;

    const images = [
            Artist.imgSuite1,
            Artist.imgSuite2,
            Artist.imgSuite3,
        ];

    return (
      <div>
        <div className="container-fluid">

          <div className="container-fluid" style={{backgroundImage: `url(${Artist.imgbg})`, height: 500+'px', width: 100+'%',  backgroundRepeat: 'no-repeat', left: 0,backgroundSize: 'cover' }} />
          

          <div className="container-fluid ">
            <div className="row justify-content-center  ">

                <div className="col-sm-12 col-md-2 m-5">
                    <div className='rounded-circle  DimImageRondArtiste' style={{backgroundImage: `url(${Artist.imgProfilRond})`,backgroundSize: 'cover' }}  />
                </div>
                
                <div className="col-sm-12 col-md-6 mt-5 m-5"> 
                    
                  <h1>
                    {Artist.NameArtist} 
                  </h1>

                  <h3>
                    {t(Artist.CategorieArtiste)}
                  </h3>
              
                  <p>
                    {t(Artist.txt)}
                  </p>

                  <div className="container-fluid">

                    <div className="row border">
                      <div className="col-md-11 my-2 h4">{t('Artistes.Reseaux')}</div>
                    </div>

                    <div className="row justify-content-md-center border">
                      { showFb? (<div className="col-md-3 m-1 text-center"><p>{t('LinksPageArtist.fb')}</p><ExternalLink href={`${Artist.fb}`}> <img width="30%" src={LogoFb} alt="logo facebook"/> </ExternalLink></div>) : ('')  }  
                    
                      {showInsta?(<div className="col-md-3 m-1 text-center"><p>{t('LinksPageArtist.insta')}</p><ExternalLink href={`${Artist.insta}`}><img width="30%" src={LogoInsta} alt="logo Insta"/></ExternalLink></div>) : ('') } 

                      {showSitePerso?(<div className="col-md-3 m-1 text-center "><p>{t('LinksPageArtist.SitePerso')}</p><ExternalLink href={`${Artist.SitePerso}`}><img width="40%" src={LinkHyperlink} alt="logo facebbok"/></ExternalLink></div>) : ('') }

                    </div>

                  </div>

                </div>
            </div>
          </div>

          <div className="container mt-5">
            <h2>{t('Artistes.General')}</h2>
            <div className="row justify-content-around ">

              <div className="card col-sm-12 col-md-3 my-4" >
                <div type="button" onClick={() => setIsOpen(true)} style={{backgroundImage: `url(${Artist.imgSuite1})`, height: 300+'px',  backgroundRepeat: 'no-repeat', left: 0,backgroundSize: 'cover' }} className="card-img-top "/>
                        <div className="card-body">
                            <p className="card-text">{t(Artist.tableaux.g1)}</p>
                        </div>
                </div>

                <div className="card col-sm-12 col-md-3 my-4" >
                    <div type="button" onClick={() => setIsOpen(true)} style={{backgroundImage: `url(${Artist.imgSuite2})`, height: 300+'px',  backgroundRepeat: 'no-repeat', left: 0,backgroundSize: 'cover' }} className="card-img-top "  />
                        <div className="card-body">
                            <p className="card-text">{t(Artist.tableaux.m1)}</p>
                        </div>
                </div>
                <div className="card col-sm-12 col-md-3 my-4" >
                    <div type="button" onClick={() => setIsOpen(true)} style={{backgroundImage: `url(${Artist.imgSuite3})`, height: 300+'px', backgroundRepeat: 'no-repeat', left: 0,backgroundSize: 'cover' }} className="card-img-top "  />
                        <div className="card-body">
                            <p className="card-text">{t(Artist.tableaux.d1)}</p>
                        </div>
                </div>

              </div>
            </div>
          </div>


        
              {isOpen && (
                    <Lightbox
                      mainSrc={images[photoIndex]}
                      nextSrc={images[(photoIndex + 1) % images.length]}
                      prevSrc={images[(photoIndex + images.length - 1) % images.length]}
                      onCloseRequest={() => setIsOpen(false)}
                      onMovePrevRequest={() =>
                        setPhotoIndex((photoIndex + images.length - 1) % images.length)
                      }
                      onMoveNextRequest={() =>
                        setPhotoIndex((photoIndex + 1) % images.length)
                      }
                    />
                )}



      </div>
    );
  
}

export default ArtistesDyn